import React from 'react';
import '../less/index.less';
import credit_protection_img from '../img/credit_protection_img.svg';
import defenceeveryday_img from '../img/defenceeveryday_img.svg';
import policy_img from '../img/policy_img.svg';
import green_policy_img from '../img/green_policy_img.svg';
import mini_casco_img from '../img/mini_casco_img.svg';
import insurance_tour_img from '../img/insurance_tour_img.svg';
import personal_insurance_img from '../img/personal_insurance_img.svg';
import insuranceItems from '../enums/insurance_items.json';
import ProductList from '../../../../../auxiliary-components/shared/ProductList';

const imagesMap = {
  credit_protection_img,
  defenceeveryday_img,
  policy_img,
  green_policy_img,
  mini_casco_img,
  insurance_tour_img,
  personal_insurance_img
};

export default function template() {
  const page = 'insurance-list';

  const insuranceData = insuranceItems.map(item => ({
    ...item,
    img: imagesMap[item.img]
  }));

  return (
    <div className="insurance-list">
      <ProductList
        title="INSURANCE_LIST_NEW_TITLE"
        items={insuranceData}
        page={page}
      />
    </div>
  );
}
